/**
 * Add base URL to route.
 * @param {string} url Route.
 * @param {string} baseURL Base website URL
 */
export default function (url, baseURL = process.env.VUE_APP_PUBLIC_API_URL) {
    return baseURL + url;
}
